import { removeFileNamePrefix, getTenant } from '../../utils'

export default function FileLink(props) {
  const { fileName, jwt } = props
  console.log('FileLink rendered: ', props)

  const tenant = getTenant()

  return (
    <a data-cy="file-link" href={`${process.env.REACT_APP_SERVER}/file/${tenant}/${escape(fileName)}?jwt=${jwt}`} target="_blank" rel="noreferrer" style={{ padding: '0px' }}>
      {removeFileNamePrefix(fileName, '/')}
    </a>
  )
}
